













































































































































































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { ServiceRequestModel } from '../../types/request';
import { MapUtils } from '@/util/mapUtils';
import { ModelSelect } from 'vue-search-select';
import AddRxProviderModal from '../modal/AddRxProviderModal.vue';
import { ObjectFactory } from '@/config/objectFactory';
import { RxProvider } from '@/types/entity';
import { CommonUtils } from '@/util/commonUtils';
// tslint:disable-next-line: no-var-requires
const validationErrorMessages = require('../../config/validationErrorMessages.json');

declare var google: any;
@Component({
    props: {
        serviceRequest: Object,
    },
    components: {
        AddRxProviderModal,
        ModelSelect,
    },
    data() {
        return {
            rxProvidersOptions: [],
            phone: '',
            validationErrorMessages: [],
            showRequiredFieldMessage: false,
        };
    },
    watch: {
        serviceRequest: {
            handler(newValue, oldValue) {
                if (this.$v.$invalid) {
                    this.$props.serviceRequest.stops.isStop2Valid = false;
                } else {
                    this.$props.serviceRequest.stops.isStop2Valid = true;
                }
            },
            deep: true,
            immediate: true,
        },
    },
    validations() {
        const validations = {
            serviceRequest: {
                facility: {
                    name: {
                        required,
                    },
                    email: {
                        required,
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(10),
                        regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
                    },
                    address: {
                        fullAddress: {
                            required,
                        },
                        state: {
                            required,
                        },
                        city: {
                            required,
                        },
                        zip: {
                            required,
                        },
                    },
                },
                delivery: {
                    deliveryItems: {
                        required,
                        minLength: minLength(1),
                    },
                    businessCloseTime: {
                        required,
                    },
                },
                cmr: {
                    healthInsuranceName: {
                        required,
                    },
                },
            },
            item: {
                minLength: minLength(2),
            },
        };
        if (this.$props.serviceRequest.delivery.isCmr) {
            delete validations.serviceRequest.facility;
            delete validations.serviceRequest.delivery;
            delete validations.item;
        } else {
            delete validations.serviceRequest.cmr;
        }
        this.$data.validationErrorMessages = [];

        const isEmpty = (value: any) => {
            return value === undefined || value === null || value === '';
        };
        const checkFields = (data: any, validationRules: any, path = '') => {
            Object.keys(validationRules).forEach((fieldName) => {
                const fieldValidation = validationRules[fieldName];
                const fieldPath = path ? `${path}.${fieldName}` : fieldName;
                if (fieldValidation.required) {
                    const fieldValueInServiceRequest = getField(this.$props.serviceRequest, fieldPath);
                    if (fieldPath.includes('deliveryItems') && this.$props.serviceRequest.delivery.deliveryItems) {
                        const keys = ['delivery', 'deliveryItems'];
                        let value = validationErrorMessages;
                        for (const key of keys) {
                            value = value[key];
                        }
                        if (value) {
                            this.$data.validationErrorMessages.push(value);
                        }
                    }
                    if (isEmpty(fieldValueInServiceRequest)) {
                        const fieldValueInData = getField(data, fieldPath);
                        if (isEmpty(fieldValueInData)) {
                            const formattedName = fieldPath.replace(/([A-Z])/g, ' $1').trim().toLowerCase();
                            if (formattedName.includes('address')) {
                                const stringsWithAddress = this.$data.validationErrorMessages.
                                findIndex((str: any) => str.includes('address'));
                                if (stringsWithAddress === -1) {
                                    const keys = fieldPath.split('.');
                                    let value = validationErrorMessages;
                                    for (const key of keys) {
                                        value = value[key];
                                    }
                                    if (value) {
                                        this.$data.validationErrorMessages.push(value);
                                    }
                                }
                            } else {
                                const keys = fieldPath.split('.');
                                let value = validationErrorMessages;
                                for (const key of keys) {
                                    value = value[key];
                                }
                                if (value) {
                                    this.$data.validationErrorMessages.push(value);
                                }
                            }
                        }
                    }
                }
                if (typeof fieldValidation === 'object') {
                    checkFields(data, fieldValidation, fieldPath);
                }
            });
        };

        const getField = (data: any, fieldPath: any) => {
            const pathArray = fieldPath.split('.');
            let value = data;
            for (const pathItem of pathArray) {
                if (!value) {
                    return undefined;
                }
                value = value[pathItem];
                if (value === undefined) {
                    break;
                }
            }
            return value;
        };
        checkFields(this.$data, validations.serviceRequest);
        return validations;
    },
})
export default class PickupDetails extends Vue {
    private facilityGoogleAddress: any;
    private item = '';
    private showAddRxProviderForm = false;
    private rxProviders: RxProvider[] = [];


    public mounted() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (!serviceRequest.stops.isStop1Valid) {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_SERVICE_VISIT });
            return;
        }
        if (serviceRequest.delivery && !serviceRequest.delivery.isCmr) {
            this.facilityGoogleAddress = new google.maps.places.Autocomplete(this.$refs.facilityAddress,
            { types: ['geocode'] });
            this.facilityGoogleAddress.addListener('place_changed', () => {
                this.$props.serviceRequest.facility.address = MapUtils.parseGoogleAddress(this.facilityGoogleAddress);
            });
            this.getRxProviderList();
        }
    }


    private validateTime() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.delivery && serviceRequest.delivery.businessCloseTime) {
            let time = new Array();
            time = serviceRequest.delivery.businessCloseTime.split(':');
            const hours = parseInt(time[0], 10);
            const minutes = parseInt(time[1], 10);
            if (isNaN(hours) || 0 > hours || hours >= 24 || isNaN(minutes) || 0 > minutes || minutes >= 60) {
                serviceRequest.delivery.businessCloseTime = '';
            }
        }
    }

    private showAddRxProvider() {
        this.showAddRxProviderForm = true;
    }

    private async getRxProviderList() {
        const response = await ObjectFactory.getRxProviderService()
            .getRxProviders(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.rxProviders = response.data as any;
        this.$data.rxProvidersOptions = [];
        this.rxProviders.forEach((rxProvider) => {
            if (rxProvider.status === 'ACTIVE') {
                const providersOption = {
                    value: rxProvider.fullname,
                    text: rxProvider.fullname,
                };
                this.$data.rxProvidersOptions.push(providersOption);
            }
        });
    }

    private copyRxProvider(fullname: string) {
        if (this.rxProviders) {
            this.rxProviders.forEach((rxProvider) => {
                if (rxProvider.fullname === fullname) {
                    if (rxProvider.address) {
                        this.$props.serviceRequest.facility.address = rxProvider.address;
                    } else {
                        this.$props.serviceRequest.facility.address = {
                            city: '',
                            fullAddress: '',
                            state: '',
                            zip: '',
                        };
                    }
                    this.$props.serviceRequest.delivery.businessCloseTime = rxProvider.businessCloseTime ?
                    rxProvider.businessCloseTime : '';
                    this.$props.serviceRequest.facility.email = rxProvider.email ? rxProvider.email : '';
                    if (rxProvider.phone) {
                        this.$data.phone = rxProvider.phone.trim();
                        this.$props.serviceRequest.facility.phone = rxProvider.phone.trim();
                    }
                }
            });
        }
    }

    private nextStep() {
        if (this.$v.$invalid) {
            this.$data.showRequiredFieldMessage = true;
        } else {
            this.$props.serviceRequest.stops.isStop2Valid = true;
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_ADDRESS_BILLING });
        }
    }

    private preStep() {
        this.$router.go(-1);
    }

    private addDeliveryItem() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.delivery && this.item && !this.$v.item.$invalid) {
            const found = serviceRequest.delivery.deliveryItems.indexOf(this.item);
            if (found! < 0) {
                serviceRequest.delivery.deliveryItems.push(this.item);
            }
            this.item = '';
        }
    }
   private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }
    private removeDeliveryItem(index: number) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.delivery) {
            serviceRequest.delivery.deliveryItems.splice(index, 1);
        }
    }
}
